import {
  Flex,
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
  Text,
} from "@chakra-ui/react";
import { PanoramaViewModel } from "../api/ManagerApi";

interface Props {
  view: PanoramaViewModel;
  updateView: (newView: PanoramaViewModel) => void;
}

export const PanoViewOptions = ({ view, updateView }: Props) => {
  return (
    <Flex p={2} gap={2}>
      <FormControl variant="floating" flex={2}>
        <FormLabel>
          <Text fontSize="md">Verticale kijkrichting</Text>
        </FormLabel>
        <NumberInput
          defaultValue={view.direction?.latitude ?? 0}
          onChange={(vas, van) =>
            updateView({
              ...view,
              direction: {
                latitude: van || 0,
                longitude: view.direction?.longitude ?? 0,
              },
            })
          }
        >
          <NumberInputField />
        </NumberInput>
      </FormControl>
      <FormControl variant="floating" flex={2}>
        <FormLabel>
          <Text fontSize="md">Horizontale kijkrichting</Text>
        </FormLabel>
        <NumberInput
          defaultValue={view.direction?.longitude ?? 0}
          onChange={(vas, van) =>
            updateView({
              ...view,
              direction: {
                latitude: view.direction?.latitude ?? 0,
                longitude: van || 0,
              },
            })
          }
        >
          <NumberInputField />
        </NumberInput>
      </FormControl>
      <FormControl variant="floating" flex={2}>
        <FormLabel>
          <Text fontSize="md">Zichtveld</Text>
        </FormLabel>
        <NumberInput
          defaultValue={view.fieldOfView ?? 70}
          onChange={(vas, van) =>
            updateView({
              ...view,
              fieldOfView: van || 70,
              direction: {
                latitude: view.direction?.latitude ?? 0,
                longitude: view.direction?.longitude ?? 0,
              },
            })
          }
        >
          <NumberInputField />
        </NumberInput>
      </FormControl>
    </Flex>
  );
};
